export default {
  methods: {
    alignment(alignment) {
      if (alignment === 'centre') {
        return 'center';
      } else if (alignment === 'left') {
        return 'left';
      } else {
        return 'right';
      }
    }
  }
};
